import { render } from "./modal.vue?vue&type=template&id=153113a6&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=153113a6&scoped=true&lang=css"
import "./modal.vue?vue&type=style&index=1&id=153113a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-153113a6"

export default script